import React, {useEffect, useState} from "react";
import Layout from "../../layout/Layout/Layout";
import {Box} from "@mui/material";
import {DataGrid, GridCellParams} from "@mui/x-data-grid";
import axios from "axios";
import 'react-responsive-modal/styles.css';
import {Modal} from 'react-responsive-modal';
import {toast} from "react-toastify";
import Loader from "../loader/loader";
import {APP_CONFIGURATION} from "../../app-config/configuration";


interface SponsorshipDetails {
    id: number;
    fullName: string;
    designation: string;
    companyName: string;
    industryType: string;
    contactEmail: string;
    phoneNumber: string;
    sponsorshipCategory: string;
    businessGoals: string;
    budgetRange: string;
    comments: string;
    attachmentPath: string | null;
}

const Sponsorship = () => {
    const [blogData, setBlogData] = useState<SponsorshipDetails[]>([]);
    const [open, setOpen] = useState(false);
    const [deleteId, setDeleteId] = useState<string>()
    const [loading, setLoading] = useState<boolean>(false)

    const onOpenModal = (id: any) => {
        setOpen(true);
        setDeleteId(id)
    }
    const onCloseModal = () => setOpen(false);

    const handleDelete = () => {
        const payload = {
            id: deleteId
        }
        setLoading(true)
        // @ts-ignore
        axios.post(`${APP_CONFIGURATION.APP_CONSTANT.API_URL}api/v0/deleteBlog`, payload, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        })
            .then((res) => {
                if (res.status) {
                    setLoading(false)
                    toast.success("Deleted Successfully");
                    onCloseModal()
                    getAllBlog()
                }
            })
            .catch((err) => {
                // Handle the error
            });
    }
    const handleEdit = (id: string) => {
        window.location.replace(`/create-blog/${id}`);
    }
    const columns = [
        {
            field: "srNo",
            headerName: "Sr. No.",
            width: 60,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as number}</div>
            ),
        },
        {
            field: "fullName",
            headerName: "Full Name",
            width: 200,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string}</div>
            ),
        },
        {
            field: "designation",
            headerName: "Designation",
            width: 150,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string}</div>
            ),
        },
        {
            field: "companyName",
            headerName: "Company Name",
            width: 200,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string}</div>
            ),
        },
        {
            field: "industryType",
            headerName: "Industry Type",
            width: 150,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string}</div>
            ),
        },
        {
            field: "contactEmail",
            headerName: "Contact Email",
            width: 250,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string}</div>
            ),
        },
        {
            field: "phoneNumber",
            headerName: "Phone Number",
            width: 150,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string}</div>
            ),
        },
        {
            field: "sponsorshipCategory",
            headerName: "Sponsorship Category",
            width: 200,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string}</div>
            ),
        },
        {
            field: "businessGoals",
            headerName: "Business Goals",
            width: 300,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string}</div>
            ),
        },
        {
            field: "budgetRange",
            headerName: "Budget Range",
            width: 200,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string}</div>
            ),
        },
        {
            field: "comments",
            headerName: "Comments",
            width: 300,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string}</div>
            ),
        },
        {
            field: "attachmentPath",
            headerName: "Attachment",
            width: 200,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>
                    {params.value ? (
                        <a href={params.value as string} target="_blank" rel="noopener noreferrer">
                            View Attachment
                        </a>
                    ) : (
                        "No Attachment"
                    )}
                </div>
            ),
        },
    ];



    useEffect(() => {
        getAllBlog()
    }, []);
    const getAllBlog = () => {
        setLoading(true)
        axios
            .get(`https://gatewayapi-uat.worldtradingleagues.com/api/v1/ifi/all-sponsorship-data`)
            .then((res) => {
                console.log('res' , res.data)
                const blogDataWithKeys = res.data.map((item: SponsorshipDetails, index: number) => ({
                    ...item,
                    id: item.id.toString(),
                    srNo: index + 1, // Add a new property for Sr. No.
                }));
                setBlogData(blogDataWithKeys);
                setLoading(false)
            })
            .catch(() => {
            });
    }

    // @ts-ignore
    return (
        <>
            <Layout>
                <main id="main" className="main">
                    <div className="pagetitle mt-3">
                        <h1>Sponsorship</h1>
                        <nav>
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    Home
                                </li>
                                <li className="breadcrumb-item active">Sponsorship</li>
                            </ol>
                        </nav>
                    </div>
                    <section className="section dashboard">
                        <Loader loading={loading}/>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12 mt-5">
                                    <Box>
                                        <DataGrid
                                            rows={blogData}
                                            columns={columns}
                                            pagination
                                            // rowCount={blogData.length}
                                            // pageSizeOptions={[10, 15, 25]}
                                        />
                                    </Box>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>
                <Modal open={open} onClose={onCloseModal} center>
                    <div className='p-5 text-center'>
                        <h3>Are You Sure You Want to Delete?</h3>
                        <div className="mt-3">
                            <button className="btn btn-danger ml-5" onClick={handleDelete}>Yes</button>
                            <button className="btn btn-secondary mr-4" style={{marginLeft: '10px'}}
                                    onClick={onCloseModal}>Cancel
                            </button>
                        </div>
                    </div>
                </Modal>
            </Layout>
        </>
    );
};

export default Sponsorship;
